import { AppBar, Tab, Tabs } from "@material-ui/core";
import React from "react";
import { styles } from "./styles";
import { withStyles } from "@material-ui/core/styles";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import Loading from "../loading";
import Snackbar from "../snackbar";
import Header from "../../partials/header";
import DeviceManage from "./deviceManage";
import SmsManage from "./smsManage";
class SMS extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      isAddPayment: false,
      arrange_date: {
        filter_by: "createdAt",
        from: new Date(new Date().setDate(new Date().getDate() - 1)).setHours(
          0,
          0,
          0,
          0
        ), // mặc định là từ 1 ngày trước ngày hiện tại
        to: new Date().setHours(23, 59, 59, 999), // nếu mặc định là '' => api sẽ bỏ qua không kiểm tra thời gian khi get list
      },
    };
    this.getListForSMS = this.getListForSMS.bind(this)
  }
  async getListForSMS(payload) {
    let { arrange_date } = this.state;
    let { status } = this.SmsManage.state
    let filter_exact = [];
    if (arrange_date.from && arrange_date.to)
      filter_exact.push({ arrange_date: arrange_date });
    if (status !== -1) filter_exact.push({ status: status });
    this.loading.startLoading();
    await this.props.getListSMS({
      filter_exact: filter_exact,
      ...payload,
    });
    this.loading.stopLoading();
    this.SmsManage.checkListFilter()
  };
  handleChangeTab = (event, value) => {
    this.setState({ tab: value });
  };
  handleFilterSMSDate = (from, to) => {
    const { arrange_date } = this.state;
    arrange_date.from = from ? new Date(from).setHours(0, 0, 0, 0) : null;
    arrange_date.to = to ? new Date(to).setHours(23, 59, 59, 999) : null;
    this.setState({ arrange_date: arrange_date }, function () {
      this.getListForSMS();
    });
  }
  render() {
    const { tab, arrange_date } = this.state;
    const { t, classes, ipAddress, roleId, ...props } = this.props;
    return (
      <React.Fragment>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        {/* Header  */}
        {tab === 0 && (
          <Header
            session={roleId.role === "admin" ? t("sidebar_superadmin") : t("sidebar_manage")}
            title={t("sms_tag_sms_manage")}
            showFilterDate={true}
            handleFilterDate={this.handleFilterSMSDate}
            titleToolipIconDateRange={t("sms_filter_by_time")}
            from={arrange_date.from} // mặc định là từ 1 ngày trước ngày hiện tại
            to={arrange_date.to}
          />
        )}
        {tab === 1 &&
          <Header
            session={roleId.role === "admin" ? t("sidebar_superadmin") : t("sidebar_manage")}
            title={t("sms_tag_device_manage")}
          />
        }
        {/* Body */}
        <AppBar
          position="static"
          color="default"
          className={classes.appTabs}
        >
          <Tabs
            value={tab}
            onChange={this.handleChangeTab}
            indicatorColor="secondary"
            textColor="primary"
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
              fixed: classes.tabsFixed,
            }}
            scrollButtons="on"
            variant="scrollable"
          >
            <Tab
              label={t(
                "sms_tag_sms_manage"
              )}
              classes={{
                root: classes.tabRoot,
                textColorPrimary: classes.textColorPrimary,
                selected: classes.selected,
              }}
            />
            <Tab
              label={t(
                "sms_tag_device_manage"
              )}
              classes={{
                root: classes.tabRoot,
                textColorPrimary: classes.textColorPrimary,
                selected: classes.selected,
              }}
            />
          </Tabs>
        </AppBar>
        {tab === 0 && (
          <SmsManage onRef={smsManage => this.SmsManage = smsManage} getListForSMS={this.getListForSMS} {...props} />
        )}
        {tab === 1 &&
          <DeviceManage {...props} />
        }
      </React.Fragment>
    );
  }
}

const mapState = (state) => ({
  roleId: state.user.user.roleId
});

const mapDispatch = (dispatch) => ({
  getListSMS: dispatch.sms.getList,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(SMS)));
